import {takeLatest} from 'redux-saga/effects';
import {call, put} from 'redux-saga/effects';
import axios from 'axios';
import {actions, actionTypes} from '../Redux/index';
import qs from 'qs';

import {downloadPath} from "../endpoint";

function* requestFile(args) {

    let type = args.payload.type;
    const data = args.payload.data;
    const opts = args.payload.options;

    let { baseUrl, finalType } = (() => {
        if (!opts) return { baseUrl: downloadPath, finalType: type };
        if (opts.settlement) return { baseUrl: `${downloadPath}/settlements`, finalType: type };
        if (opts.average) return { baseUrl: `${downloadPath}/yearly-average/`, finalType: `${opts.year}.${type}` };
        if (opts.monthly) return { baseUrl: `${downloadPath}/monthly-overview/${opts.year}/`, finalType: `${opts.month}.${type}` };
        if (opts.monthlyUltimo) return { baseUrl: `${downloadPath}/monthly-average/${opts.year}/`, finalType: `${opts.month}.${type}` };
        if (opts.EndofMonthRates) return { baseUrl: `${downloadPath}/end-of-month/${opts.year}/`, finalType: `${opts.month}.${type}` };
        return { baseUrl: downloadPath, finalType: type };
    })();

    try {
        yield put(actions.Data.Download.sagaDownloadFileStart());

        const requestConfig = {
            method: 'post',
            baseURL: baseUrl,
            url: finalType,
            withCredentials: false,
            crossDomain: true,
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: qs.stringify(data)
        };

        const response = yield call(axios, requestConfig);

        let filename = `download.${finalType}`;
        if (response.headers.hasOwnProperty('content-disposition')){
            const cp = response.headers['content-disposition'];
            filename = cp.slice(cp.indexOf('filename=') + 9, cp.length);
        }

        const cType = response.headers['content-type'];
        const blob = new Blob([response.data], {type: cType});

        if (typeof window.navigator.msSaveBlob !== "undefined") {
            // IE workaround 
            window.navigator.msSaveBlob(blob, filename);
        } else {
            const URL = window.URL || window.webkitURL;
            const downloadUrl = URL.createObjectURL(blob);

            // use HTML5 a[download] attribute to specify filename
            const a = document.createElement("a");
            a.setAttribute('style', 'display: none');
            // safari 9.x doesn't support this
            if (typeof a.download === 'undefined') {
                const reader = new FileReader();
                reader.onload = function(){
                    window.location.href = reader.result;
                };
                reader.readAsDataURL(blob);

            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
            }
        }

        yield put(actions.Data.Download.sagaDownloadFileSuccess());

    } catch (e) {
        console.error(e);
        yield put(actions.Data.Download.sagaDownloadFileError(e));
    }

}

export default function* downLoadFile() {
    yield takeLatest(actionTypes.Data.Download.REQUEST_DOWNLOAD_FILE, requestFile);
}